import { Badge } from '@capawesome/capacitor-badge';
import { isNativePlatform } from './index';

// The red number on the app icon. iOS shows it only after the member allows
// notifications (the push permission prompt covers badges). Always applied,
// never deduped: push payloads change the icon number behind the app's back.
export async function setAppBadge(count: number): Promise<void> {
  if (!isNativePlatform) return;
  try {
    const { display } = await Badge.checkPermissions();
    if (display !== 'granted') return;
    if (count > 0) await Badge.set({ count });
    else await Badge.clear();
  } catch {
    // Some Android launchers have no badge support; the in-app dots still work.
  }
}

export async function clearAppBadge(): Promise<void> {
  if (!isNativePlatform) return;
  try {
    await Badge.clear();
  } catch {
    // Nothing to clear on launchers without badge support.
  }
}
